import { Badge, Flex, Paper, Text } from '@mantine/core';
import type { CandidateReview } from '@entities/candidateReview';
import { formatRatingValue } from '@shared/utils';
import dayjs from 'dayjs';

type CandidateReviewCardProps = {
  review: CandidateReview;
};

export const CandidateReviewCard = ({ review }: CandidateReviewCardProps) => {
  const reviewDate = review.reviewAt
    ? dayjs(review.reviewAt).format('DD.MM.YYYY, HH:mm')
    : '-';

  const ratingLabel =
    review.ratingTotal != null
      ? `${formatRatingValue(review.ratingTotal)} из 5`
      : '-';

  return (
    <Paper p={16} radius={12} bg='primary.0' w='100%'>
      <Flex direction='column' gap={12}>
        <Flex align='center' justify='space-between' gap={8} wrap='wrap'>
          <Flex gap={8} align='center' wrap='wrap'>
            <Badge
              variant='filled'
              color='primary'
              radius={8}
              fw={600}
              fz={20}
              h={32}
            >
              {ratingLabel}
            </Badge>

            {review.isHired === true && (
              <Badge variant='light' color='green' size='sm' h={32}>
                Был нанят
              </Badge>
            )}

            {review.isHired === false && (
              <Badge variant='light' color='red' size='sm' h={32}>
                Не был нанят
              </Badge>
            )}
          </Flex>

          <Text size='sm' c='tertiary.7'>
            {reviewDate}
          </Text>
        </Flex>

        <Text size='sm' fw={600}>
          {review.company.name}
        </Text>

        <Text c='tertiary.5' size='sm' fw={600}>
          {review.vacancy.name}
        </Text>
      </Flex>
    </Paper>
  );
};
